<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing"
  >
    <div
      class="card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30"
    >
      <div
        class="card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 mb-4"
      >
        <button class="btn btn-primary" @click="openModal">
          + Nouveau Sheet
        </button>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <h3 class="text-center mb-3">Exemplaire d'en-tête excel sheet</h3>

          <!-- Alert 1 -->
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
          >
            <i class="feather icon-alert-triangle me-2"></i>
            <span>Merci de respecter les noms des villes</span>
          </div>

          <!-- Alert 2 -->
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
          >
            <i class="feather icon-alert-triangle me-2"></i>
            <span>
              La colonne <strong>"ID"</strong> est obligatoire et ne doit pas
              être dupliquée
            </span>
          </div>

          <!-- Table -->
          <div class="table-responsive table-scroll-mobile">
            <table class="table text-nowrap align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>ID</th>
                  <th>CODE</th>
                  <th>DESTINATAIRE</th>
                  <th>TELEPHONE</th>
                  <th>PRIX</th>
                  <th>VILLE</th>
                  <th>ADRESSE</th>
                  <th>COMMENTAIRE</th>
                  <th>PRODUIT</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>

      <hr />
      <div class="table-responsive table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr class="bg-gray-100">
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nom
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Clé
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            <template v-if="sheets.length > 0">
              <tr v-for="s in sheets" :key="s.id">
                <td class="fw-medium text-black-emphasis">
                  {{ s.sheet_name }}
                </td>
                <td class="fw-medium text-black-emphasis">
                  {{ s.sheet_key }}
                </td>
                <td class="fw-medium text-black-emphasis">
                  {{ s.created_at }}
                </td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="removeSheet(s.id)"
                  >
                    🗑
                  </button>
                </td>
              </tr>
            </template>

            <!-- No data row -->
            <tr v-else>
              <td colspan="4" class="text-center text-muted py-4">
                <span>Aucune donnée disponible</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- MODAL -->
  <div
    class="modal fade"
    id="addSheetyModal"
    tabindex="-1"
    aria-hidden="true"
    ref="addSheetyModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Nouveau Google Sheet</h1>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <div class="alert alert-primary mb-3">
            La colonne <b>ID</b> est obligatoire et unique
          </div>

          <input
            v-model="form.sheet_name"
            class="form-control mb-3"
            placeholder="Nom du sheet"
          />

          <input
            v-model="form.sheet_key"
            class="form-control mb-3"
            placeholder="Clé Google Sheet"
          />
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeModal">Annuler</button>
          <button
            class="btn btn-primary d-flex align-items-center"
            @click="submit"
            :disabled="loading"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>

            {{ loading ? "Traitement..." : "Appliquer" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";

const sheets = ref<any[]>([]);
const showModal = ref(false);
const { showToast } = useAppToast();

const form = ref({
  sheet_name: "",
  sheet_key: "",
});

const loadSheets = async () => {
  const { data } = await api.get("/api/auth/client/sheets");
  sheets.value = data.data;
};

onMounted(loadSheets);
const loading = ref(false);

const submit = async () => {
  if (loading.value) return; // 🔒 prevent double submit

  loading.value = true;

  try {
    const res = await api.post("/api/auth/client/sheets", form.value);

    if (res.data?.success) {
      showToast("Sheet ajouté avec succès", "success");
      closeModal();
      await loadSheets();
    } else {
      showToast(
        res.data?.message ?? "Erreur lors de l'ajout du sheet",
        "error"
      );
    }
  } catch (error) {
    console.error("Submit error:", error);

    showToast(error.response?.data?.message ?? "Erreur serveur", "error");
  } finally {
    loading.value = false; // ✅ ALWAYS restore
  }
};

const removeSheet = async (id: number) => {
  Swal.fire({
    text: "Vous voulez supprimer ce sheet ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      await api.delete(`/api/auth/client/sheets/${id}`);
      loadSheets();
    }
  });
};

const importModel = async () => {
  try {
    const response = await api.get("/api/auth/client/ModelSheetExcel", {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "ModelSheetExcel.xlsx";

    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel model:", error);
    // Optional: show toast / alert
  }
};

const addSheetyModal = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;

onMounted(() => {
  if (addSheetyModal.value) {
    modalInstance = new Modal(addSheetyModal.value, {
      backdrop: "static",
      keyboard: false,
    });
  }
});

const openModal = () => {
  modalInstance?.show();
};

const closeModal = () => {
  modalInstance?.hide();
};
</script>
